import DetailSubscription from "@dropDesk/presentation/components/detail_subscription";
import React from "react";
import {
    ContentDetail,
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/styled";
import {PaymentMethodEntity} from "@dropDesk/domain/entities/payment_method/payment_method.entity";
import {
    ContentInfos, DescriptionWrapper, IconBadge, IconWrapper,
} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/payment_method/styled";
import ButtonMain from "@dropDesk/presentation/components/buttons/button_main";
import {ContentButton} from "@dropDesk/presentation/pages/subscription/ui/detail_subscription/payment_info/styled";
import {useInjection} from "inversify-react";
import {AppController} from "@dropDesk/presentation/app/app.controller";
import {HighLightHashTag} from "@dropDesk/presentation/components/high_light_hashtag";
import {observer} from "mobx-react";
import DropDeskIcon from "@dropDesk/storage/icons";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";

const PaymentMethod = observer((
    {
        paymentMethod,
        loading,
        disabled,
        handleEditPaymentMethod,
    }: {
        paymentMethod: PaymentMethodEntity
        loading: boolean
        disabled: boolean
        handleEditPaymentMethod: () => void
    }
) => {

    const appController = useInjection(AppController);
    const colors = appController.theme.colorScheme;

    const getIconFromPaymentMethod = (paymentMethod: PaymentMethodEntity): string => {
        if (!!paymentMethod.card) {
            return ICONS_DROPDESK.creditCard;
        }

        if (!!paymentMethod.boleto) {
            return ICONS_DROPDESK.billet;
        }
        return ICONS_DROPDESK.pix;
    }

    return (
        <DetailSubscription
            style={{marginRight: 25}}
            title={'Forma de pagamento'}
            description={'Método de pagamento utilizado para suas cobranças.'}
            content={
                <ContentDetail background={'transparent'}>
                    <ContentInfos>
                        <IconWrapper>
                            <IconBadge background={`${colors.accent}12`}>
                                <DropDeskIcon icon={getIconFromPaymentMethod(paymentMethod)} size={20} color={colors.accent}/>
                            </IconBadge>
                        </IconWrapper>
                        <DescriptionWrapper>
                            <HighLightHashTag fontSize={15} text={paymentMethod.paymentMethodChangeLabel}/>
                        </DescriptionWrapper>

                    </ContentInfos>
                    <ContentButton>
                        <ButtonMain
                            style={{paddingLeft: 10, paddingRight: 5}}
                            widthPercentage={100}
                            letterFontSize={12}
                            disabled={disabled}
                            loading={loading}
                            height={35}
                            color={colors.background}
                            borderColor={colors.accent}
                            letterColor={colors.accent}
                            useSuffixIcon={true}
                            type={"submit"}
                            letter={'Trocar pagamento'}
                            onClick={() => handleEditPaymentMethod()}
                        />
                    </ContentButton>
                </ContentDetail>
            }
        />
    );
});
export default PaymentMethod;
